import { useIntl } from "@grandvisionhq/state";
import { useSunglassesEcommContext } from "../../../../../context/modules/EcommContent/SunglassesEcommContent/context/SunglassesEcommContext.js";
const useSunglassesPriceFrom = () => {
  const { getLabel } = useIntl();
  const { shouldDisplayFromPrice } = useSunglassesEcommContext();
  const fromPricePrefix = shouldDisplayFromPrice ? getLabel("products.price.sunglasses.from", { hideLabelKey: true }) : void 0;
  return {
    shouldDisplayFromPrice,
    fromPricePrefix
  };
};
export {
  useSunglassesPriceFrom
};
//# sourceMappingURL=use-sunglasses-price-from.js.map
